import { useEffect } from "react"

import { MessageName } from "../constants"
import { MessagePayloads } from "../types"

export default function useMessageListener<K extends MessageName>(
    messageName: K,
    onMessageReceived: (payload: MessagePayloads[K]) => void
): void {
    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            // check if the origin matches the current origin for security reasons
            if (event.origin !== window.location.origin) {
                return
            }

            if (event.data && event.data.name === messageName) {
                const payload = event.data.payload as MessagePayloads[K]
                onMessageReceived(payload)
            }
        }

        window.addEventListener("message", handleMessage)

        // cleanup listener on unmount
        return () => {
            window.removeEventListener("message", handleMessage)
        }
    }, [messageName, onMessageReceived])
}
